import { BREAKPOINTS } from '../constants.js'

export const doesMenuObstructStage = () => window.innerWidth < BREAKPOINTS.MD
